<template>
    <transition name="slide"
        v-on:enter="enter"
        v-on:beforeLeave="beforeLeave"
        v-bind:css="false"
        duration="200" apper>

        <div id='conteudo-container' ref="conteudo" >
            
                <div class="close" v-to="'/'"> <i class='fa fa-times'></i> </div>
                
                <!-- <div v-scroll> -->
                    <div class='scroll-content'> 
                        <hr>
                        <div v-if="ajax">
                            <ajaxcontent :url="getContentURL()"></ajaxcontent>

                        </div>
                        <slot></slot>
                    </div>
                <!-- </div>  -->
        </div>

    </transition>
</template>


<script>

   export default {
    data () {
        return {
            open:false,
            loading: false,
            post: null,
            error: null,
            className:'col-4'
        }

    },

    props:{
        ajax:{
            default:true,
        },
        url:{
            default:false,
        },
        

    },


    created () {
    },

    mounted:function(){
        this.$nextTick(
            ()=>this.show()
        )
    },

    beforeRouteEnter(to, from, next) {
        console.log("***************** route beforeRouteEnter")
        setTimeout(next,400)
    },

    beforeRouteUpdate(to, from, next) {
        console.log("*****************route beforeRouteUpdate")
        next();
    },
 
    beforeRouteLeave(to, from, next) {
        console.log("*****************route beforeRouteLeave")
        this.hide();
        setTimeout(next,400)
        // next();
    },


    watch: {
        // call again the method if the route changes
        '$route':function (to, from) {
            console.log('***********************router watch');
            console.log(from);
            var className = _.get(to,'meta.contentClass','col-11 col-md-4');
            this.className = className;
            var $conteudo = $(this.$refs.conteudo);
            $conteudo.attr('class',className);

            this.show();
        },
    },



    methods: {

        enter: function (el, done) {
            console.log("***************** transition enter")
            console.log(el)
            setTimeout(()=>this.show(),500);
            done()
        },

        beforeLeave: function (el, done) {
            console.log("***************** transition before leave")
            //  console.log(el)
            this.hide()
            // done()
        },

        getContentURL:function(){

            var path = this.$route.params.id;
            var url = _.get(this.$route.meta,'url.'+path);

            if( url ){     
                return   `${window.API.apiurl}htmls/_generated/${this.$store.getters.currentLang}${url}`;  //`${window.API.server}${this.$store.getters.currentLang}${url}`
            }else{
                return `${window.API.server}${this.$store.getters.currentLang}/paginas/${path}`
            }
           
        },
        
        show:function(){

            this.$nextTick( ()=>{
                //pego a classe do elemento
                var className = this.$route.meta.contentClass;
                this.className = className;
                var $conteudo = $(this.$refs.conteudo);
                $conteudo.attr('class',className);
                var width = $conteudo.width();

                var time = 0.9
                var delay = 0.2

                if(this.open ===false){
                    this.open = true

                    // TweenMax.fromTo( "#menu-wrap" ,time, {x:0,rotateY:90}, {width: 90, rotationY:0, transformOrigin:"left top", x:width, delay:(delay+0.3), ease: Back.easeOut.config(1) } )                        
                    // TweenMax.fromTo( "#backgroundOrange" ,time-0.2, {width:4}, {width: "100%", delay:(delay-0.03), ease: Back.easeOut.config(1.7) } )

                    // TweenMax.fromTo( this.$refs.conteudo,time, {x: -width,autoAlpha:1}, {x:0,delay:delay, autoAlpha:1, ease: Back.easeOut.config(1) } )
                
                    // TweenMax.to( "#mapaBaseLayer", time, {left: (width+$("#menu-wrap").width()), right:0, delay:delay+0.5, autoAlpha:1, ease: Back.easeOut.config(0.2), onUpdate:()=>{
                    //     UIEvents.$emit('resizeMapContainer')
                    // } } )
                        
                
                }
            })
        },


                
        hide:function(){
            //  if(this.open === true){
            //     this.open = false
            //     var $conteudo = $(this.$refs.conteudo);
            //     var width = $conteudo.width();
            //     var time = 0.8
             
            //     TweenMax.to( this.$refs.conteudo,time, {x: -width,autoAlpha:0, delay:0, autoAlpha:1, ease: Back.easeOut.config(1)} )
            //     TweenMax.to( "#mapaBaseLayer", time, {left: 0, right:0, delay:0, autoAlpha:1, ease: Back.easeOut.config(1), onUpdate:()=>{
            //             UIEvents.$emit('resizeMapContainer')
            //     } } )
            //     TweenMax.to( "#menu-wrap" ,time, {width: 115, x:0, rotationY:0, transformOrigin:"left top", delay:0.02, ease: Back.easeOut.config(1) } )
            //     TweenMax.to( "#backgroundOrange" ,time/2, {width:4, delay:(time-0.4), ease: Back.easeOut.config(1) } )
              
             
            //  }
        },


    }
    }

</script>


<style lang="stylus">

    @import "./../css/variaveis"

    #conteudo-container{
       
        box t 0 b 0 l 0 w 550

        transform translate3d(0,0,0)
    
        background  color-dark-gray;
        overflow:auto;
    
        color:#cfd0cf;
        font-family font-text;
        padding:0;


        .close{
            box abs r 0 t 0 w 35 h 35
            background color-orange 
            line-height 35px
            text-align center 
            color white
            z-index 100
            opacity 1
            margin 0
            padding 0
            i{
                line-height: 35px;
            }
        }

        // padding 100px 20px
        // border-right:115px solid color-gray;
        .scroll-content{
            padding:20px 35px;    
            min-height 90%;

          
        }


        +mobile(){
            
                min-width: 100%; //para subscrever o setilo que passo tipo col-5
                border-top:3px solid color-orange;
                overflow: visible;
                // margin-top: 85vh;
                position:relative;
                max-width: 100% !important;
                width: 100% !important;


            }

    }


</style>
